import {remoteUrl, urlWithParams} from "../../helpers/UrlHelpers";

const STICKER_MAKER_URL = process.env.REACT_APP_STICKER_MAKER_URL;
const DEFAULT_PARAMS    = { order_by: 'id', order: 'desc' };

function stickerPackPath(this: any, id: number) {
  return `/${this.basePath}/sticker_packs/${id}`;
}

function contentPath(this: any, params: object = DEFAULT_PARAMS) {
  return urlWithParams(`/${this.basePath}/content`, params);
}
function contentTrendingPath(this: any, params?: object) {
  return urlWithParams(`/${this.basePath}/content/trending`, params);
}
function contentPopularPath(this: any, params?: object) {
  return urlWithParams(`/${this.basePath}/content/popular`, params);
}
function contentRecentsPath(this: any, params?: object) {
  return urlWithParams(`/${this.basePath}/content/recents`, params);
}

function communityPath(this: any, params: object = DEFAULT_PARAMS) {
  return urlWithParams(`/${this.basePath}/community`, params);
}
function communityTrendingPath(this: any, params?: object) {
  return urlWithParams(`/${this.basePath}/community/trending`, params);
}
function communityPopularPath(this: any, params?: object) {
  return urlWithParams(`/${this.basePath}/community/popular`, params);
}
function communityRecentsPath(this: any, params?: object) {
  return urlWithParams(`/${this.basePath}/community/recents`, params);
}

function reviewsPath(this: any, params: object = DEFAULT_PARAMS) {
  return urlWithParams(`/${this.basePath}/reviews/packs`, params);
}
function stickersReviewsPath(this: any, params: object = DEFAULT_PARAMS) {
  return urlWithParams(`/${this.basePath}/reviews`, params);
}

function usersPath(this: any, params: object = DEFAULT_PARAMS) {
  return urlWithParams(`/${this.basePath}/users`, params);
}
function userPath(this: any, id: number) {
  return `/${this.basePath}/users/${id}`;
}

function assetsPath(this: any, params: object = DEFAULT_PARAMS) {
  return urlWithParams(`/${this.basePath}/assets`, params);
}
function assetsSvgPath(this: any, params?: object) {
  return urlWithParams(`/${this.basePath}/assets/svg`, params);
}
function assetsExtrasPath(this: any, params?: object) {
  return urlWithParams(`/${this.basePath}/assets/extras`, params);
}

function reportsPath(this: any, params: object = DEFAULT_PARAMS) {
  return urlWithParams(`/${this.basePath}/reports`, params);
}

const stickerMakerUrls = {
  baseURL:    STICKER_MAKER_URL,
  basePath:   'sticker_maker',
  remoteUrl:  remoteUrl,

  stickerPackPath:        stickerPackPath,

  contentPath:            contentPath,
  contentTrendingPath:    contentTrendingPath,
  contentPopularPath:     contentPopularPath,
  contentRecentsPath:     contentRecentsPath,

  communityPath:          communityPath,
  communityTrendingPath:  communityTrendingPath,
  communityPopularPath:   communityPopularPath,
  communityRecentsPath:   communityRecentsPath,

  reviewsPath:            reviewsPath,
  stickersReviewsPath:    stickersReviewsPath,

  usersPath:              usersPath,
  userPath:               userPath,

  assetsPath:             assetsPath,
  assetsSvgPath:          assetsSvgPath,
  assetsExtrasPath:       assetsExtrasPath,

  reportsPath:            reportsPath,
}

export default stickerMakerUrls;
